// import logo from './logo.svg';
// import './App.css';
import HOMESCREEN from './components/homepage/homescreenf/Homescreen'
import VIEWCOURSES from './components/viewcoursespage/viewcourses/Viewcourses';
import TESTIMONIALS from './components/testimonials/Testimonials';
import {BrowserRouter,Route,Routes} from 'react-router-dom'
import React, {useState } from 'react';
import Homeg from './components/homepage/homescreenf/homeg/Homeg'
import rolllaptop from './components/homepage/homescreenf/homeg/Laptop'



const homege = Homeg

function App() {
  let [show, setShow] = useState(rolllaptop);
  let [homeg,sethomeg] = useState(homege)
  
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route
            path="/"
            element={<HOMESCREEN show={show} setShow={setShow} />}
          ></Route>
          <Route
            path="/viewcourses"
            element={<VIEWCOURSES show={homeg} setShow={sethomeg}/>}
          ></Route>
          <Route
            path="/testimonials"
            element={<TESTIMONIALS show={homeg} setShow={sethomeg}/>}
          ></Route>
        </Routes>
        
      </div>
      
    </BrowserRouter>
  );
}

export default App;
